<template>
  <div class="content if-profile">
    <div class="md-layout if-profile-body">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header"
      >
        <div class="md-layout">
          <div
            class="md-layout-item md-medium-size-65 md-xsmall-size-100 md-size-30"
          >
            <div
              class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-70"
            >
              <collapse
                :collapse="['Company List']"
                icon="keyboard_arrow_down"
                color-collapse="info"
                :active="false"
              >
                <template slot="md-collapse-pane-1">
                  <div class="financal-report-col-1">
                    <div>
                      <small>December 2020</small>
                    </div>
                    <div
                      class="md-layout-item md-medium-size-15 md-xsmall-size-100 md-size-30"
                    >
                      <img src="/img/image_placeholder.jpg" />
                    </div>
                  </div>
                </template>
              </collapse>
            </div>
          </div>
          <div
            class="md-layout-item md-medium-size-35 md-xsmall-size-100 md-size-70"
          >
            <div class="md-layout fi-profile-pdf-box">
              <div
                class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-15"
              >
                <md-button
                  class="md-info md-block access-button"
                  >CSV <md-icon class="ml-5">table_rows</md-icon>
                </md-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="md-layout-item md-size-100">
        <md-card>
          <div class="md-toolbar-row map-box-title">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-100 md-size-80">
                <md-card-header class="md-card-header-icon">
                  <h1 class="md-title text-left profile-title">
                    Company Summary
                  </h1>
                </md-card-header>
              </div>
              <div class="md-layout-item md-medium-size-100 md-size-20">
                <md-card-header class="md-card-header-icon">
                  <md-button
                    class="md-dense md-info md-block access-button md-layout-item"
                  >
                    Upgrade
                  </md-button>
                </md-card-header>
              </div>
            </div>
          </div>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-100 md-size-100">
                <div class="md-layout">
                  <div class="md-layout-item md-medium-size-100 md-size-50">
                    <div
                      class="md-card md-card-profile multiples-text-card md-theme-default"
                    >
                      <div
                        class="md-card-header md-card-header-icon md-card-header-blue"
                      ></div>
                      <div
                        v-if="companySummary !== null"
                        class="md-card-content"
                        md-alignment="left"
                      >
                        <span class="md-subheading">{{
                          companySummary.businessName
                        }}</span>
                        <div>
                          <small>
                            {{
                              `${
                                companySummary.zip4
                                  ? companySummary.zip4 + ","
                                  : ""
                              } ${companySummary.city}, ${
                                companySummary.locAddress
                                  ? companySummary.locAddress + ","
                                  : ""
                              } ${companySummary.state}, ${companySummary.zip}`
                            }}
                            <br />
                            <br />
                            <b>{{
                              `${
                                companySummary.contacTitle
                                  ? companySummary.contacTitle
                                  : "Contact"
                              }:`
                            }}</b>
                            {{
                              `${companySummary.contactFirst} ${companySummary.contactLast}`
                            }}<br />
                            <b>Phone: </b> {{ `${companySummary.phonePrimary}`
                            }}<br />
                            <b>URL: </b
                            >{{ companySummary.url ? companySummary.url : "" }}
                            <br />
                            <br />
                          </small>
                        </div>
                        <div>
                          <small>
                            <b>Mailing Address: </b
                            >{{
                              companySummary.mailAddress
                                ? companySummary.mailAddress
                                : ""
                            }}<br />
                            <br />
                          </small>
                        </div>
                        <div>
                          <small>
                            <b>Industry: </b
                            >{{
                              `[${companySummary.bznaics}] ${companySummary.industry}`
                            }}<br />
                            <br />
                          </small>
                        </div>
                        <div>
                          <small>
                            <b>Estimated Sales: </b>{{ companySummary.sales
                            }}<br />
                            <b>Estimated Employment: </b>
                            {{ companySummary.locationEmp }}<br />
                            <b>Earnings Approach Median Value: </b
                            >{{ companySummary.earningsMedian }}
                            <br />
                            <b>Credit.net Score: </b
                            >{{ companySummary.creditNetScore }}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="md-layout-item md-medium-size-100 md-size-50">
                    <div
                      class="md-card md-card-profile multiples-text-card md-theme-default"
                    >
                      <div
                        class="md-card-header md-card-header-icon md-card-header-blue"
                      ></div>
                      <div class="md-card-content" md-alignment="left">
                        <iframe
                          src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d6090.785711241515!2d-76.90951427207703!3d40.24479970678012!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sPO%20Box%2072%20Lemoyne%20PA%2017043!5e0!3m2!1sen!2s!4v1624635371410!5m2!1sen!2s"
                          width="600"
                          height="800"
                          style="border:0;"
                          allowfullscreen=""
                          loading="lazy"
                        >
                        </iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Collapse } from "@/components";
import {} from "@/components";

export default {
  components: {
    Collapse,
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    companySummary() {
      return this.$store.getters.companySummary;
    },
  },
};
</script>

<style lang="scss">
.introduction-body {
  display: flex;
  align-items: flex-start;
}

.company-list-title {
  margin: 0 !important;
}
.introduction-title {
  display: flex;
  flex-direction: column;
  justify-content: end;
}

.if-profile-body {
  .companis-list-tabl {
    .favorite-list-item {
      .list-item-head {
        align-items: center;
      }
    }
  }

  iframe {
    height: 320px;
  }
}

.map-box-title {
  padding: 0 24px;
}
</style>
